import merge from 'lodash/merge';
import cloneDeep from 'lodash/cloneDeep';
import baseDefaults from '../Base/Base.defaults';
import baseImageDefaults from '../BaseImage/BaseImage.defaults';
import BasePlayButtonDefaults from '../BasePlayButton/BasePlayButton.defaults';

const defaults = {
  ...cloneDeep(baseDefaults),
  action: {type: 'none'},
  image: merge(cloneDeep(baseImageDefaults), {
    width: 'custom',
    customWidth: {
      desktop: {
        value: 400,
        unit: 'px',
      },
    },
  }),
  overlay: 'none', // none, playButton,
  playButton: cloneDeep(BasePlayButtonDefaults),
  lightbox: false,
};

export default defaults;
